import { createContext } from 'react'

export type NavBlockerContextType = {
  setBlocker: (value: boolean) => void
}

export const NavBlockerContext = createContext<
  NavBlockerContextType | undefined
>(undefined)
